// Animações feitas em JS (digitação, contador, troca de palavras) consultam
// isto; as feitas em CSS já são desligadas pelo media query no theme.css.
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
